export * from './Page_DiseaseProfile.js';
//# sourceMappingURL=index.js.map